(function () {
  if (window.ssPromoOfferBound) return;
  window.ssPromoOfferBound = true;

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: currency || 'EUR'
    }).format(cents / 100);
  }

  function fillTemplate(template, values) {
    let output = template || '';

    Object.keys(values).forEach(function (key) {
      const token = '[' + key + ']';
      output = output.split(token).join(values[key]);
    });

    return output;
  }

  function getCartSectionIds() {
    const ids = new Set();

    const cartItemsComponent = document.querySelector('cart-items-component[data-section-id]');
    if (cartItemsComponent && cartItemsComponent.dataset.sectionId) {
      ids.add(cartItemsComponent.dataset.sectionId);
    }

    const cartDrawerComponent = document.querySelector('cart-drawer-component');
    const headerSection = cartDrawerComponent && cartDrawerComponent.closest('[id^="shopify-section-"]');
    if (headerSection && headerSection.id) {
      ids.add(headerSection.id.replace('shopify-section-', ''));
    }

    return Array.from(ids);
  }

  function replaceSection(sectionId, html) {
    if (!html) return;

    const currentSection = document.getElementById('shopify-section-' + sectionId);
    if (!currentSection) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newSection = doc.getElementById('shopify-section-' + sectionId);

    if (!newSection) return;

    currentSection.replaceWith(newSection);
  }

  function renderSectionsFromResponse(responseData) {
    if (!responseData || !responseData.sections) return;

    Object.entries(responseData.sections).forEach(function ([sectionId, html]) {
      replaceSection(sectionId, html);
    });
  }

  function openCartDrawer() {
    const dialog = document.querySelector('cart-drawer-component dialog');
    if (dialog && dialog.hasAttribute('open')) return;

    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) trigger.click();
  }

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.js-add-with-discount');
    if (!button) return;

    event.preventDefault();
    if (button.disabled) return;

    const variantId = Number(button.dataset.variantId);
    const promoCode = button.dataset.promoCode;
    const requiredVendor = button.dataset.requiredVendor;
    const minimumCents = Number(button.dataset.minimumCents);

    const labelDefaultTemplate = button.dataset.labelDefault || "Profiter de l'offre [brand]";
    const labelCheckingTemplate = button.dataset.labelChecking || 'Vérification...';
    const labelAddingTemplate = button.dataset.labelAdding || 'Ajout en cours...';
    const labelAddedTemplate = button.dataset.labelAdded || 'Ajouté au panier';

    const alertTitle = button.dataset.alertTitle || 'Offre non applicable :';
    const alertBodyTemplate = button.dataset.alertBodyTemplate || '';

    const errorCartText = button.dataset.errorCart || 'Impossible de lire le panier.';
    const errorAddText = button.dataset.errorAdd || "Erreur lors de l'ajout au panier.";
    const errorDiscountText = button.dataset.errorDiscount || "Erreur lors de l'application du code promo.";
    const errorGenericText = button.dataset.errorGeneric || 'Une erreur est survenue.';

    const originalText = fillTemplate(labelDefaultTemplate, {
      brand: requiredVendor
    });

    try {
      button.disabled = true;
      button.innerText = fillTemplate(labelCheckingTemplate, {
        brand: requiredVendor
      });

      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!cartResponse.ok) {
        throw new Error(errorCartText);
      }

      const cart = await cartResponse.json();

      let totalBrand = 0;

      cart.items.forEach(function (item) {
        if ((item.vendor || '').trim().toUpperCase() === requiredVendor.trim().toUpperCase()) {
          totalBrand += (item.final_line_price != null ? item.final_line_price : item.line_price);
        }
      });

      if (totalBrand < minimumCents) {
        const missing = minimumCents - totalBrand;

        const translatedAlertBody = fillTemplate(alertBodyTemplate, {
          minimum: formatMoney(minimumCents, cart.currency),
          brand: requiredVendor
        });

        alert(alertTitle + '\n\n' + translatedAlertBody);
        return;
      }

      const sectionIds = getCartSectionIds();
      const sectionsUrl = window.location.pathname + window.location.search;

      button.innerText = fillTemplate(labelAddingTemplate, {
        brand: requiredVendor
      });

      const addPayload = {
        items: [{ id: variantId, quantity: 1 }]
      };

      if (sectionIds.length) {
        addPayload.sections = sectionIds;
        addPayload.sections_url = sectionsUrl;
      }

      const addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(addPayload)
      });

      const addData = await addResponse.json();

      if (!addResponse.ok) {
        throw new Error(addData.description || addData.message || errorAddText);
      }

      renderSectionsFromResponse(addData);

      const updatePayload = {
        discount: promoCode
      };

      if (sectionIds.length) {
        updatePayload.sections = sectionIds;
        updatePayload.sections_url = sectionsUrl;
      }

      const discountResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(updatePayload)
      });

      const updatedCart = await discountResponse.json();

      if (!discountResponse.ok) {
        throw new Error(
          updatedCart.description ||
          updatedCart.message ||
          errorDiscountText
        );
      }

      renderSectionsFromResponse(updatedCart);

      button.innerText = fillTemplate(labelAddedTemplate, {
        brand: requiredVendor
      });

      if (window.location.pathname === '/cart') {
        window.location.reload();
        return;
      }

      setTimeout(function () {
        openCartDrawer();
      }, 80);

    } catch (error) {
      console.error('Erreur :', error);
      alert(error.message || errorGenericText);
    } finally {
      setTimeout(function () {
        button.disabled = false;
        button.innerText = originalText;
      }, 3000);
    }
  });
})();
